export const PEOPLE_SOURCE_ID = 'people';
export const MY_CITY_SOURCE_ID = 'my-city';
export const SELECTED_SOURCE_ID = 'people-selected';

export const myCityPulseLayer = {
  id: 'my-city-pulse',
  type: 'circle',
  source: MY_CITY_SOURCE_ID,
  paint: {
    'circle-color': '#6ea8ff',
    'circle-radius': 22,
    'circle-opacity': 0.22,
    'circle-stroke-width': 0,
  },
};

export const myCityLayer = {
  id: 'my-city-marker',
  type: 'circle',
  source: MY_CITY_SOURCE_ID,
  paint: {
    'circle-color': '#6ea8ff',
    'circle-radius': 10,
    'circle-stroke-width': 3,
    'circle-stroke-color': '#faf9f6',
  },
};

export const clusterLayer = {
  id: 'people-clusters',
  type: 'circle',
  source: PEOPLE_SOURCE_ID,
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': [
      'step',
      ['get', 'point_count'],
      '#6b6b75',
      10,
      '#4a4a54',
      50,
      '#2f2f38',
    ],
    'circle-radius': [
      'step',
      ['get', 'point_count'],
      18,
      10,
      24,
      50,
      32,
    ],
    'circle-stroke-width': 2,
    'circle-stroke-color': '#faf9f6',
  },
};

export const clusterCountLayer = {
  id: 'people-cluster-count',
  type: 'symbol',
  source: PEOPLE_SOURCE_ID,
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-size': 12,
  },
  paint: {
    'text-color': '#faf9f6',
  },
};

export const unclusteredPointLayer = {
  id: 'people-unclustered',
  type: 'circle',
  source: PEOPLE_SOURCE_ID,
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-color': [
      'case',
      ['==', ['get', 'hasMe'], 1],
      '#6ea8ff',
      '#2f2f38',
    ],
    'circle-radius': [
      'step',
      ['get', 'count'],
      14,
      5,
      18,
      20,
      22,
    ],
    'circle-stroke-width': 2,
    'circle-stroke-color': '#faf9f6',
  },
};

export const unclusteredCountLayer = {
  id: 'people-unclustered-count',
  type: 'symbol',
  source: PEOPLE_SOURCE_ID,
  filter: ['!', ['has', 'point_count']],
  layout: {
    'text-field': ['to-string', ['get', 'count']],
    'text-size': 11,
  },
  paint: {
    'text-color': '#faf9f6',
  },
};

export const selectedPulseLayer = {
  id: 'people-selected-pulse',
  type: 'circle',
  source: SELECTED_SOURCE_ID,
  paint: {
    'circle-color': '#6ea8ff',
    'circle-radius': 28,
    'circle-opacity': 0.28,
    'circle-stroke-width': 0,
  },
};

export const selectedPointLayer = {
  id: 'people-selected-point',
  type: 'circle',
  source: SELECTED_SOURCE_ID,
  paint: {
    'circle-color': '#6ea8ff',
    'circle-radius': [
      'step',
      ['get', 'count'],
      18,
      5,
      22,
      20,
      26,
    ],
    'circle-stroke-width': 3,
    'circle-stroke-color': '#faf9f6',
  },
};

export const selectedCountLayer = {
  id: 'people-selected-count',
  type: 'symbol',
  source: SELECTED_SOURCE_ID,
  layout: {
    'text-field': ['to-string', ['get', 'count']],
    'text-size': 12,
  },
  paint: {
    'text-color': '#faf9f6',
  },
};

export const interactiveLayerIds = [
  clusterLayer.id,
  clusterCountLayer.id,
  unclusteredPointLayer.id,
  unclusteredCountLayer.id,
  myCityLayer.id,
  myCityPulseLayer.id,
];
